
class GiftPackaging extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-gift-toggle]');
    this.variant = Number(this.dataset.variant);
    if (!this.toggle || !this.variant) return;

    this.toggle.addEventListener('change', () => this.apply(this.toggle.checked));
  }

  async apply(on) {
    this.toggle.disabled = true;
    try {
      if (on) {
        await window.CartAPI.add(
          [{ id: this.variant, quantity: 1, properties: { _gift_packaging: 'yes' } }],
          { source: 'gift-packaging' },
        );
      } else {
        const cart = await window.CartAPI.get();
        const line = (cart.items || []).findIndex((i) => i.variant_id === this.variant);
        if (line >= 0) {
          await window.CartAPI.change({ line: line + 1, quantity: 0 }, { source: 'gift-packaging' });
        }
      }
    } catch (e) {
      this.toggle.checked = !on;   
    } finally {
      this.toggle.disabled = false;
    }
  }
}

customElements.define('gift-packaging', GiftPackaging);
